"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getValueByPresentation;
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _constants = _interopRequireDefault(require("../../constants"));
var _presentations = require("../../utils/presentations");
function getValueByPresentation(choice, presentationName) {
  if ((0, _isNil["default"])(choice)) {
    return '';
  }
  if (presentationName === null || (0, _presentations.isPresentationUsingShortLabelAsChoiceValue)(presentationName)) {
    return choice.shortLabel;
  }
  if ((0, _presentations.isPresentationUsingEmptyAsChoiceValue)(presentationName)) {
    return '';
  }
  if ((0, _presentations.isPresentationStartingWithNullValue)(presentationName)) {
    return null;
  }
  if ((0, _presentations.isPresentationUsingMinValueAsChoiceValue)(presentationName)) {
    return choice.minValue;
  }
  if ((0, _presentations.isPresentationUsingDefaultMinAndMaxValues)(presentationName)) {
    return _constants["default"].defaultMinValue;
  }
  return choice.shortLabel;
}
//# sourceMappingURL=choiceFunctions.js.map